import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectPublicUserTrackingInfo } from 'redux/root.selectors';

type MicrosoftClarityProps = {
  start: boolean;
};

declare global {
  interface Window {
    clarity: {
      (action: string, ...args: any[]): void;
      q?: any[][];
    };
  }
}

const MicrosoftClarity = ({ start }: MicrosoftClarityProps) => {
  const [clarityLoaded, setClarityLoaded] = useState(false);
  const publicUserTrackingInfo = useSelector(selectPublicUserTrackingInfo);

  useEffect(() => {
    if (clarityLoaded && publicUserTrackingInfo) {
      window.clarity('set', 'photoSeriesId', publicUserTrackingInfo.photoSeries.id);
      window.clarity('set', 'customerName', publicUserTrackingInfo.customerName || '');

      // https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-consent-api-v2
      window.clarity('consentv2', {
        ad_Storage: 'denied', // ads
        analytics_Storage: 'granted'
      });
    }
  }, [clarityLoaded, publicUserTrackingInfo]);

  useEffect(() => {
    if (
      process.env.REACT_APP_CLARITY_PROJECT_ID &&
      start
    ) {
      // Remove any existing script before adding a new one
      const existingScript = document.getElementById('clarity-script');
      if (existingScript) {
        existingScript.remove();
      }

      // Initialize Microsoft Clarity
      const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

      // Microsoft Clarity initialization pattern
      window.clarity = window.clarity || function clarity(...args) {
        (window.clarity.q = window.clarity.q || []).push(args);
      };

      // Create the script element to load the Microsoft Clarity script
      const scriptElement = document.createElement('script');
      scriptElement.id = 'clarity-script';
      scriptElement.async = true;
      scriptElement.src = `https://www.clarity.ms/tag/${clarityProjectId}`;
      scriptElement.onload = () => {
        setClarityLoaded(true);
      };
      scriptElement.onerror = () => {
        console.warn('Failed to load Microsoft Clarity script');
      };

      // Insert the script into the document head
      document.head.appendChild(scriptElement);
    }

    return () => {
      // Cleanup script if needed
      const existingScript = document.getElementById('clarity-script');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [start]);

  return null;
};

export default MicrosoftClarity;
